import memoize from 'memoize-one'

/**
 * Checks if the browser supports the webkit directory upload feature.
 *
 * This function is memoized to avoid repeated DOM queries. It checks if the
 * 'webkitdirectory' attribute is supported on input elements, which allows
 * users to select entire directories for upload.
 *
 * @returns True if webkit directory upload is supported, false otherwise
 *
 * @example
 * ```typescript
 * if (webkitDirectorySupported()) {
 *   // Show directory upload option
 *   inputElement.setAttribute('webkitdirectory', '')
 * } else {
 *   // Fallback to file-only upload
 * }
 * ```
 */
export const webkitDirectorySupported: () => boolean = memoize(
  () => 'webkitdirectory' in document.createElement('input'),
)

export const isApple =
  typeof navigator !== 'undefined' &&
  /Mac|iPod|iPhone|iPad/.test(navigator.userAgent)
